import React from 'react'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Navbar from '../components/Navbar'
import Banner from '../components/Banner'
import TrainingSection from '../components/Exhibit'
import SponsorForm from '../components/forms/SponsorForm'
// import Features from '../components/features/Features'
import MultiItemCarousel from '../components/partners/MultiItemCarousel'

const Sponsor = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='Sponsor' text=' Learn more about becoming a Sponsor / Exhibitor' />
            <SponsorForm />
            <Banner />
            <TrainingSection />
            <MultiItemCarousel />
            <Footer />
        </div>
    )
}

export default Sponsor
